export default "__VITE_ASSET__a50a2464__"